module.exports = __webpack_public_path__ + "img/no-cart-item.f443833f.jpg";